export default {
    CARD_CLOSED: 'card-closed',
    CARD_SHOWN: 'card-shown',
    CARD_HIDDEN: 'card-hidden',
    CONFIG_CHANGED: 'config-changed',
};
//# sourceMappingURL=events.js.map